import { render, staticRenderFns } from "./LdCharts.component.vue?vue&type=template&id=f70816ce&scoped=true&"
import script from "./LdCharts.component.vue?vue&type=script&lang=js&"
export * from "./LdCharts.component.vue?vue&type=script&lang=js&"
import style0 from "./LdCharts.component.vue?vue&type=style&index=0&id=f70816ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70816ce",
  null
  
)

export default component.exports